<mat-icon *ngIf="icon">{{ icon }}</mat-icon>
<h4 class="mat-h4">
    {{ title }}{{ value || value === 0 ? ':' : ''}} {{ value || value === 0 ? value : ''}}
</h4>